import { gql } from 'graphql-tag';

export const CREATE_EMAIL_ALERT = gql`
    mutation createEmailAlert($input: SearchFields!) {
        createNewEmailAlert(input: $input) {
            status
            statusText
            body
        }
    }
`;
